/* istanbul ignore file */
import axios from 'axios';
import { from } from 'rxjs';
import { map } from 'rxjs/operators';

export const getCustomersList = () =>
  from(axios.post('/authentication/emulation/listCustomers')).pipe(
    map(({ data: { data } }) => data)
  );

export const getUsersList = (code) =>
  from(axios.post('/authentication/emulation/listUsers', { customerCode: code })).pipe(
    map(({ data: { data } }) => data)
  );
